import PopupActions from '../../redux/actions/popupActions';

const Redirect = () => {
    const { clearPopup, selectedTool } = PopupActions();
    return (
		<>
			<button
				className="popup__remove-close"
				onClick={() => {
					clearPopup();
				}}
			></button>
			<div className="popup__redirect">
				<div className="popup__description">
					<p>Due to switching between tools changes won’t be applied. To save image, please click the “Download” button on previous screen.</p>
				</div>
                <div className='popup__buttons'>
                    <button className='popup__buttons_cancel'
                    onClick={() => {
                        clearPopup();
                    }}
                    >Cancel</button>
                    <button className='popup__buttons_continue'
                    onClick={() => {
                        location.href = `/image-${selectedTool}`;
                    }}
                    >Continue anyway</button>
                </div>
			</div>
		</>
	);
}

export default Redirect;
